module.exports = __webpack_public_path__ + "files/8a2a6bbae15f1405be86b1f20964aaf9.png";